// static/src/composables/useProspectingChatContext.js
//
// Gives AIChatWidget the data it needs to answer prospecting-specific
// questions — coverage gaps, past search performance, tier limits,
// uncategorized leads, campaign structure. Same module-level-ref pattern
// as useReportChatContext.js: AIChatWidget is a SIBLING of <router-view>,
// so inject() can't reach it.
//
// ProspectingPage.vue calls setProspectingChatContext() when the page
// loads / data changes, and clearProspectingChatContext() on unmount so
// the context doesn't leak into the chat on unrelated pages.

import { ref } from 'vue';

const prospectingChatContext = ref(null);

/** @returns {import('vue').Ref<object|null>} */
export function useProspectingChatContext() {
  return prospectingChatContext;
}

export function setProspectingChatContext(ctx) {
  prospectingChatContext.value = ctx;
}

export function clearProspectingChatContext() {
  prospectingChatContext.value = null;
}
